export class PlanAdapter {
  static toInputDTO(req: any): any {
    return req.filter((e: any) => e.value).map((e: any) => e.key);
  }

  static toOutputDTO(res: any): any {
    return (
      res?.data?.map((e: any) => ({
        id: e.plan_id,
        key: e.name,
        value: false,
      })) || []
    );
  }
}
